export default __webpack_public_path__ + "static/media/ies.f4e95cf8.csv";